import React, { useState, useEffect } from "react";
import API from "../../Service/Baseservice";
import { useNavigate, useLocation, useParams } from "react-router-dom";

const NewsCategoryEdit = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();

    const [formData, setFormData] = useState({
        newscategory_id: "",
        language_id: "",
        news_id: "",
        category_name: "",
        icon_image: "",
        description: "",
        status: "active",
        active: 1,
        updatedBy: 1,
    });

    const [selectedImage, setSelectedImage] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [popup, setPopup] = useState({ show: false, type: "", message: "" });
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (location.state?.category) {
            const cat = location.state.category;
            console.log("Loaded from location.state:", cat);
            setFormData({
                newscategory_id: cat.newscategory_id,
                language_id: cat.language_id,
                news_id: cat.news_id,
                category_name: cat.category_name,
                icon_image: cat.icon_image || "",
                description: cat.description,
                updatedBy: 1,
            });
            setPreviewImage(cat.icon_image || null);
        } else if (id) {
            console.log("Fetching from API for ID:", id);
            API.post("newscategory_list/condition", { newscategory_id: id })
                .then((res) => {
                    const data = res.data?.data?.[0];
                    if (data) {
                        setFormData({
                            newscategory_id: data.newscategory_id,
                            language_id: data.language_id,
                            news_id: data.news_id,
                            category_name: data.category_name,
                            icon_image: data.icon_image || "",
                            description: data.description,
                            updatedBy: 1,
                        });
                        setPreviewImage(data.icon_image || null);
                    }
                })
                .catch((err) => console.error("Error fetching category:", err));
        } else {
            console.error("No category found in location.state or params");
        }
    }, [location.state, id]);

    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    useEffect(() => {
        if (!selectedImage) return;

        setIsUploading(true);
        toBase64(selectedImage)
            .then((base64) => {
                const uploadPayload = {
                    name: "Icon Image",
                    image: [
                        {
                            name: selectedImage.name,
                            type: selectedImage.type,
                            size: `${selectedImage.size} bytes`,
                            base64: base64,
                        },
                    ],
                };
                return API.post("imageUpload/add", uploadPayload);
            })
            .then((res) => {
                if (res.data && res.data.success && res.data.url) {
                    setFormData((prev) => ({
                        ...prev,
                        icon_image: res.data.url,
                    }));
                    setPreviewImage(res.data.url);
                } else {
                    throw new Error("Upload failed");
                }
            })
            .catch((err) => {
                console.error("Image upload failed:", err);
                setPopup({
                    show: true,
                    type: "error",
                    message: "Image upload failed. Please try again.",
                });
            })
            .finally(() => setIsUploading(false));
    }, [selectedImage]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedImage(file);
            setPreviewImage(URL.createObjectURL(file));
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.icon_image || !formData.language_id || !formData.category_name || !formData.description) {
            setPopup({
                show: true,
                type: "info",
                message: "Please fill all required fields.",
            });
            return;
        }

        setIsSubmitting(true);

        const payload = {
            ...formData,
            status: "active",
            active: 1,
        };

        API.post("newscategory_edit/update", payload)
            .then((res) => {
                const success = res.data?.success;

                setPopup({
                    show: true,
                    type: success ? "success" : "error",
                    title: success ? "Success" : "Error",
                    message: success
                        ? "updated successfully!"
                        : res.data?.message || "Something went wrong",
                });
            })
            .catch((err) => {
                console.error("Update News Category Error:", err);
                setPopup({
                    show: true,
                    type: "error",
                    title: "Error",
                    message: "Failed to update News Category. Please try again.",
                });
            })
            .finally(() => setIsSubmitting(false));
    }



    return (
        <div className="category-container1">
            {/* Header */}
            <div className="category-header1">
                <h2 className="category-title1">Edit News Category</h2>
                <div className="header-buttons">
                    <button onClick={handleSubmit} className="btn saves-btn">
                        {isSubmitting ? "Update" : "Update"}
                    </button>
                    <button onClick={() => navigate("/newscategory")} className="cancel-btn ">
                        Back
                    </button>
                </div>
            </div>

            {/* Form */}
            <div className="category-form-card">
                <form>
                    <div className="image-upload-container">
                        <label htmlFor="icon_image" className="image-label">
                            {previewImage || formData.icon_image ? (
                                <img
                                    src={previewImage || formData.icon_image}
                                    alt="Preview"
                                    className="admin-image-preview"
                                    onError={(e) => {
                                        e.target.style.display = "none";
                                    }}
                                />
                            ) : (
                                <div className="image-placeholder">+</div>
                            )}
                        </label>
                        <input
                            type="file"
                            id="icon_image"
                            name="icon_image"
                            accept="image/*"
                            onChange={handleImageChange}
                            style={{ display: "none" }}
                        />
                        <p className="image-note">Click the circle to upload image</p>
                    </div>

                    <div className="cate-form-row">
                        <div className="cate-form-field">
                            <label>
                                Category Name <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                name="category_name"
                                placeholder="Enter category name"
                                value={formData.category_name}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="form-group1">
                        <label>
                            Description <span className="required">*</span>
                        </label>
                        <textarea
                            name="description"
                            placeholder="Enter description"
                            value={formData.description}
                            onChange={handleChange}
                            rows="4"
                        />
                    </div>
                </form>
            </div>

            {/* Popup */}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <div className="popup-buttons">
                            <button
                                className="btn ok-btn"
                                onClick={() => {
                                    setPopup({ ...popup, show: false });

                                    if (popup.type === "success") {
                                        navigate("/newscategory");
                                    }
                                }}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default NewsCategoryEdit;
